import React from 'react';

export function ErrorFormMessage({ message }) {
  return <p style={{ color: 'red' }}>{message}</p>;
}
